import { eoEn } from './eo';
import { profileEn } from './profile';

export const en = {
  // Common
  'common.loading': 'Loading…',
  'common.signIn': 'Sign In',
  'common.signOut': 'Sign out',
  'common.signUp': 'Sign up',
  'common.continue': 'Continue',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.submit': 'Submit',
  'common.email': 'Email',
  'common.password': 'Password',
  'common.confirmPassword': 'Confirm Password',
  'common.fullName': 'Full Name',
  'common.phone': 'Phone',
  'common.companyName': 'Company Name',
  'common.required': 'Required',
  'common.errorBoundary.title': 'Something went wrong',
  'common.errorBoundary.message':
    'The page ran into an unexpected error. You can reload and try again.',
  'common.errorBoundary.reload': 'Reload page',

  // Marketing home
  'marketing.eyebrow': 'Wellness · Sport · Cultura',
  'marketing.heroTitle': 'Wellness, Sport & Cultura in Italia',
  'marketing.heroSub':
    'Transformative experiences in iconic locations across the sea, villages and mountains, designed for people, teams and businesses who want to regenerate.',
  'marketing.requestProposal': 'Request a proposal',
  'marketing.exploreExperiences': 'Explore experiences',
  'marketing.pillarsTitle': 'Regeneration, Sport & Culture',
  'marketing.pillarsSub':
    'Programs co-designed with hosting facilities and professionals, delivering concrete wellbeing for people, teams and guests.',
  'marketing.pillar.regenerationTitle': 'Regeneration',
  'marketing.pillar.regenerationDesc':
    'Pathways that reduce stress and improve balance through mindfulness, yoga, breathwork and active listening.',
  'marketing.pillar.sportTitle': 'Sport & Nature',
  'marketing.pillar.sportDesc':
    'SUP, trekking, yoga and emerging disciplines in unique scenery from the sea to the mountains.',
  'marketing.pillar.cultureTitle': 'Culture & Gastronomy',
  'marketing.pillar.cultureDesc':
    'Immersion in local heritage, art and authentic flavours with selected guides, artisans and partners.',
  'marketing.trustTitle': 'Trust & Impact',
  'marketing.trustSub':
    'Programs designed with evidence-based facilitation and clear business outcomes for wellbeing and performance.',

  // Login (frontend)
  'login.title': 'Login',
  'login.subtitle': 'Sign in with your email and password',
  'login.failed': 'Login Failed',
  'login.signingIn': 'Signing in…',
  'login.noAccount': "Don't have an account?",

  // Signup (frontend)
  'signup.title': 'Sign up',
  'signup.subtitle': 'Complete your onboarding in three guided steps',
  'signup.step1Title': 'Your Details',
  'signup.step2Title': 'Your Company',
  'signup.step3Title': 'Confirm',
  'signup.step1Desc': 'Basic account information to get started.',
  'signup.step2Desc': 'Tell us about your company and select a role.',
  'signup.step3Desc': 'Review your details before creating your account.',
  'signup.companyRole': 'Company Role',
  'signup.create': 'Create Account',
  'signup.creating': 'Signing up…',
  'signup.failed': 'Sign Up Failed',
  'signup.haveAccount': 'Already have an account?',
  'signup.role.customer': 'Customer',
  'signup.role.customerDesc': 'Find and purchase suitable team experience packages.',
  'signup.role.travelAgency': 'Travel Agency',
  'signup.role.travelAgencyDesc': 'Organize events and publish integrated packages.',
  'signup.role.eventOrganizer': 'Event Organizer',
  'signup.role.eventOrganizerDesc': 'Create and manage event package templates.',
  'signup.role.facilityProvider': 'Facility Provider',
  'signup.role.facilityProviderDesc': 'Provide venues, accommodation and supporting facilities.',
  'signup.role.serviceProvider': 'Service Provider',
  'signup.role.serviceProviderDesc': 'Offer guided, wellness, logistics or related services.',
  'signup.role.researchPartner': 'Research Partner',
  'signup.role.researchPartnerDesc': 'Provide measurement, analytics and reporting services.',

  // Auth action handler (frontend — /auth/action)
  'authAction.verifying': 'Verifying your email…',
  'authAction.successTitle': 'Email verified!',
  'authAction.successDesc': 'Your account is now active. Taking you to your dashboard…',
  'authAction.expiredTitle': 'Link expired',
  'authAction.expiredDesc': 'This verification link has expired. Please request a new one.',
  'authAction.invalidTitle': 'Invalid link',
  'authAction.invalidDesc': 'This verification link is invalid or has already been used.',
  'authAction.errorTitle': 'Verification failed',
  'authAction.errorDesc': 'Something went wrong. Please try again.',
  'authAction.unsupportedTitle': 'Unsupported action',
  'authAction.unsupportedDesc': 'This link type is not supported.',
  'authAction.goToLogin': 'Go to login',
  'authAction.resendLink': 'Request a new verification email',

  // Verify email (frontend)
  'verifyEmail.title': 'Check your inbox',
  'verifyEmail.desc': 'We sent a verification link to',
  'verifyEmail.desc2': 'Click the link to activate your account, then return here.',
  'verifyEmail.resend': 'Resend verification email',
  'verifyEmail.resending': 'Sending…',
  'verifyEmail.resendSuccess': 'Verification email sent. Please check your inbox.',
  'verifyEmail.resendError': 'Failed to resend. Please try again.',
  'verifyEmail.checkVerified': "I've verified my email",
  'verifyEmail.checking': 'Checking…',
  'verifyEmail.notYetVerified': 'Your email is not yet verified. Please click the link in the email.',
  'verifyEmail.backToLogin': 'Sign out and return to login',

  // Frontend dashboard
  'dashboard.title': 'My Dashboard',
  'dashboard.welcome': 'Welcome back',
  'dashboard.stats.activeProposals': 'Active proposals',
  'dashboard.stats.confirmedBookings': 'Confirmed bookings',
  'dashboard.stats.upcomingRetreats': 'Upcoming retreats',
  'dashboard.stats.savedPackages': 'Saved packages',
  'dashboard.quickActionsTitle': 'Quick actions',
  'dashboard.action.companyProfile': 'Company profile',

  // Admin (backend)
  'admin.login.title': 'Admin Console',
  'admin.login.subtitle': 'Sign in to the N-Excelsior admin console.',
  'admin.login.failed': 'Login Failed',
  'admin.login.forbidden': 'This account is not authorized to access the admin console.',
  'admin.changePassword.title': 'Set a new password',
  'admin.changePassword.subtitle':
    'For security, please change your initial password before continuing.',
  'admin.changePassword.current': 'Current password',
  'admin.changePassword.new': 'New password',
  'admin.changePassword.confirm': 'Confirm new password',
  'admin.changePassword.submit': 'Update password',
  'admin.changePassword.submitting': 'Updating…',
  'admin.changePassword.tooShort': 'Password must contain at least 10 characters.',
  'admin.changePassword.forbidden': 'Please choose a password different from the default.',
  'admin.changePassword.mismatch': 'Passwords do not match.',
  'admin.changePassword.sameAsCurrent': 'New password must differ from the current one.',
  'admin.changePassword.currentRequired': 'Please enter your current password.',
  'admin.dashboard.title': 'Admin Dashboard',
  'admin.dashboard.subtitle': 'Operational overview of the N-Excelsior platform.',
  'admin.dashboard.kpi.users': 'Total users',
  'admin.dashboard.kpi.companies': 'Companies',
  'admin.dashboard.kpi.pending': 'Pending review',
  'admin.dashboard.kpi.reports': 'Reports',
  'admin.dashboard.recentTitle': 'Recent registrations',
  'admin.nav.users': 'Users',
  'admin.nav.companies': 'Companies',
  'admin.nav.operators': 'Operators',
  'admin.nav.audit': 'Audit log',

  ...eoEn,
  ...profileEn,
} as const;

export type DictionaryKey = keyof typeof en;
export type EnDictionary = Record<DictionaryKey, string>;
